import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import { IUser } from "../../graphql/types/queries/user";
import withSession from "../../lib/withSession"

export const AvatarImg = styled(Flex)`
  background: #FFE3D8;
  border-radius: 50%;
  border: 0px solid #ccc;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  & > img {
    width: 48px;
  }
`;

interface IAvatarProps {
  session: IUser
  isMinified?: boolean
  onClick?: () => void
}

const Avatar: React.FC<IAvatarProps> = ({ session, onClick=()=>{}, isMinified }) => {
  return (
    <Flex flexDirection={'row'} style={{cursor: 'pointer'}} onClick={onClick} justifyContent='center'>

      <AvatarImg style={{ alignSelf: 'center', marginRight: isMinified?0:'6px' }}>
        <img
          alt=""
          src={session.picture}
        />
      </AvatarImg>
      {!isMinified && (
        <>

          <Flex flex={1} flexDirection='column' style={{ justifyContent: 'center', margin: '0 8px' }}>
            <Text style={{ fontSize: '14px', color: 'white', fontWeight: 500 }}>{session.patientFacingName}</Text>
            <Text style={{ fontSize: '10px', color: 'white' }}>{session.email}</Text>
          </Flex>

          <Flex flexDirection={'column'} justifyContent='center'>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '12px' }}>
              <circle cx="5" cy="5" r="5" fill="white" />
            </svg>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="5" cy="5" r="5" fill="white" />
            </svg>
          </Flex>
        </>
      )}
    </Flex>
  )
}

export default withSession(Avatar)